import { render } from "./LessonTooltip.vue?vue&type=template&id=4fcc7cdd&scoped=true"
import script from "./LessonTooltip.vue?vue&type=script&lang=js"
export * from "./LessonTooltip.vue?vue&type=script&lang=js"

import "./LessonTooltip.vue?vue&type=style&index=0&id=4fcc7cdd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcc7cdd"]])

export default __exports__